<template>
    <div class="btn-group onlinebooking-timezone-select" :class="{'dropup': dropdownDirection === 'up'}">
        <a :id="`timezone-switcher-${id}`" data-toggle="dropdown" aria-haspopup="true" @click="loadTimezones">
            <slot></slot>
        </a>
        <ul :id="id" class="dropdown-menu" :class="{'dropdown-menu-right': !dropdownAlignLeft && isClientMobile, 'dropdown-menu-left': dropdownAlignLeft}" :aria-labelledby="`timezone-switcher-${id}`">
            <li v-if="timezonesLoading" class="py-2 p-l-20 p-r-20" style="width: 231px;">{{ trans('global.loading') }}...</li>
            <template v-else-if="timezonesLoaded">
                <li v-for="(value,index) in availableTimezones" @click="changeTimezone(index)" :key="index">
                    <a href="#">{{ value }}</a>
                </li>
            </template>
            <li v-else>Error... Please try again.</li>
        </ul>
    </div>
</template>

<script>
import axios from 'axios';
import { randomId } from '../../helpers';
import IsClientMobile from 'App/components/mixins/IsClientMobile'

export default {
    name: 'TimezoneSelector',

    mixins: [
        IsClientMobile,
    ],

    data() {
        return {
            id: null,
            availableTimezones: [],
            timezonesLoaded: false,
            timezonesLoading: false,
        };
    },

    beforeMount() {
        this.id = randomId();
    },

    props: {
        dropdownDirection: {
            default: 'down',
            validator: d => ['down', 'up'].includes(d),
        },

        dropdownAlignLeft: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        loadTimezones() {
            if (this.timezonesLoaded || this.timezonesLoading) {
                return false;
            }

            this.timezonesLoading = true;

            axios.get('/timezones-list')
                .then(({ data }) => {
                    this.availableTimezones = data;
                    this.timezonesLoaded = true;
                    this.timezonesLoading = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.timezonesLoading = false;
                })
        },

        changeTimezone(timezone) {
            axios
                .post('/set-ob-timezone', { timezone: timezone, user_id })
                .then(() => {
                    window.location.reload();
                })
                .catch(() => {});
        },
    },
}
</script>

<style lang="scss">
.onlinebooking-timezone-select {
    cursor: pointer;
    display: inline;
    
    ul {
        max-height: 450px;
        overflow-y: scroll;
    }

    .dropdown-menu a {
        color: #58666e !important;
    }
}
</style>
